<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Account Details</h1>

<div>
  <!-- Loading -->
  <mat-progress-spinner mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>

  <!-- Account -->
  <div *ngIf="account">
    <pre>{{account | json}}</pre>
  </div>
  <div>
    <a class="mat-raised-button" [routerLink]="['/erm/customers', account?.customerId]">View Customer</a>
  </div>

  <!-- Alarms -->
  <mat-toolbar>
    <h2>Alarms</h2>
    <span class="spacer"></span>
  </mat-toolbar>
  <div class="alarmGridContainer">
    <ag-grid-angular #agGrid class="ag-theme-alpine alarmGrid" [gridOptions]="alarmGridOptions">
    </ag-grid-angular>
  </div>

  <!-- Fleet Definitions -->
  <mat-toolbar>
    <h2>Fleet Definitions</h2>
    <span class="spacer"></span>
  </mat-toolbar>
  <div class="alarmGridContainer">
    <ag-grid-angular class="ag-theme-alpine alarmGrid" [gridOptions]="fleetDefinitionGridOptions"
    [getRowId]="getRowNodeIdForFleetDefinitionGrid">
    </ag-grid-angular>
  </div>
  <!-- Create/ Delete Fleet Definition -->
  <div class="fleet-action">
    <button mat-raised-button color="primary" (click)="openCreateFleetDefinitionDialog()">
      <mat-icon>open_in_new</mat-icon>
      Create Fleet Definition
    </button>
    <button mat-raised-button color="warn" class="button-action" (click)="deleteFleetDefinition()"
      [disabled]="canDeleteFleetDefinition()">
      <mat-icon>delete_forever</mat-icon>
      Delete Fleet Definition
    </button>
    <button mat-raised-button class="button-action" (click)="updateFleetConfiguration('fleetDefinition')"
      [disabled]="canUpdateFleetConfiguration('fleetDefinition')">
      <mat-icon>open_in_new</mat-icon>
      Add/Update Fleet Configuration
    </button>
  </div>

  <!-- Fleet Configuration -->
  <mat-toolbar>
    <h2>Fleet Configuration</h2>
    <span class="spacer"></span>
  </mat-toolbar>
  <div class="alarmGridContainer">
    <ag-grid-angular class="ag-theme-alpine alarmGrid" [gridOptions]="fleetConfigurationGridOptions"
    [getRowId]="getRowNodeIdForFleetConfigurationGrid">
    </ag-grid-angular>
  </div>
  <div class="fleet-action">
    <button mat-raised-button color="primary" (click)="updateFleetConfiguration('fleetConfiguration')"
      [disabled]="canUpdateFleetConfiguration('fleetConfiguration')">
      <mat-icon>open_in_new</mat-icon>
      Update Fleet Configuration
    </button>
    <button mat-raised-button color="warn" class="button-action" (click)="deletefleetConfiguration()"
      [disabled]="canDeletefleetConfiguration()">
      <mat-icon>delete_forever</mat-icon>
      Delete Fleet Definition
    </button>
  </div>
</div>